<template>
  <v-app id="inspire">
    <v-main>
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" xl="10" align="center" justify="center">
            <v-card class="elevation-12 app-card">
              <navigation></navigation>
              <router-view></router-view>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Navigation from "./navigation/Navigation";

export default {
  components: { Navigation },
};
</script>

<style>
.app-card {
  border-radius: 2px !important;
}
.site-title {
  padding: 30px;
  font-size: 26px;
  color: #666;
}
</style>
